import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  indexAxis: 'y',
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: true,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      grid: {
        display: false,
      },
    },
  },
};

export function HorizontalBar({ data }) {
  const labels = data.map((language) => language.languageName);
  const dataset = {
    labels: labels,
    datasets: [
      {
        barThickness: 10,
        label: 'Language Count',
        data: [6, 90],
        backgroundColor: (context) => {
          const index = context.dataIndex;
          return index % 2 === 0
            ? 'rgba(255, 99, 132, 0.5)'
            : 'rgba(53, 162, 235, 0.5)';
        },
        borderRadius: 10,
      },
    ],
  };

  return <Bar options={options} data={dataset} />;
}
